import { CreateOrUpdateBaseService } from "../../../../common/services/createOrUpdateBase.service";
import { services } from "../../../../constants/services";




export class CreateOrUpdatedWidgetsService extends CreateOrUpdateBaseService<any, any> {
  // url = `${services.userCampus}/createOrUpdateUserCampus`;
  url = `${services["chat-instances"]}`;

};

